import { useNavigate } from "react-router-dom";
import { ArrowRight, Users, Heart, Ribbon, Droplet } from "lucide-react";

const ELDER = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/369110568c1e38ef77cac9d3563a0c8d1bdeed84b8c97f464ef74592a5f8a3b9.jpeg";
const WOMEN = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/b5f3654b9a06380b6b2ecf732a7e5c8d909325194c7d11171737f9e5bcb28f4b.jpeg";
const CANCER = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/d3241c0f95846aabcc0c5ef1f3fdded2126a1cfc50419378de4acb64dcfd777c.jpeg";
const DIABETES = "https://images.pexels.com/photos/16984203/pexels-photo-16984203.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=600";

const ITEMS = [
  { key: "elder", image: ELDER, label: "Elderly Care", Icon: Users, color: "#16A34A", box: "#DCFCE7" },
  { key: "women", image: WOMEN, label: "Women Care", Icon: Heart, color: "#DB2777", box: "#FCE7F0" },
  { key: "cancer", image: CANCER, label: "Cancer Support", Icon: Ribbon, color: "#7C3AED", box: "#F3E8FF" },
  { key: "diabetes", image: DIABETES, label: "Diabetes Reversal", Icon: Droplet, color: "#0284C7", box: "#E0F2FE" },
];

export default function SpecialistCareBanner() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/specialist-care")}
      data-testid="specialist-care-banner"
      className="w-full text-left rounded-3xl p-6 transition-all hover:shadow-md"
      style={{ background: "linear-gradient(135deg,#EAF1FF 0%,#F3EEFF 100%)", border: "1px solid #DCE6FF" }}
    >
      <p className="text-xs font-extrabold tracking-[0.12em]" style={{ color: "#5B7BD6" }}>SPECIALIST CARE SERVICES</p>
      <h3 className="mt-2 text-2xl md:text-3xl font-black leading-tight" style={{ color: "#15296B" }}>
        Dedicated Care.<br />For Every Stage of Life.
      </h3>

      <div className="mt-6 grid grid-cols-4 gap-3">
        {ITEMS.map((it) => (
          <div
            key={it.key}
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); navigate("/specialist-care"); }}
            className="flex flex-col items-center text-center"
            data-testid={`specialist-chip-${it.key}`}
          >
            <div className="relative">
              <img src={it.image} alt={it.label} className="h-16 w-16 rounded-full object-cover border-2 border-white shadow-sm" />
              <span className="absolute -bottom-1 -left-1 h-7 w-7 rounded-full flex items-center justify-center border-2 border-white" style={{ backgroundColor: it.box }}>
                <it.Icon className="h-3.5 w-3.5" style={{ color: it.color }} />
              </span>
            </div>
            <span className="mt-2.5 text-[11px] font-bold leading-tight" style={{ color: "#334155" }}>{it.label}</span>
          </div>
        ))}
      </div>

      <div
        data-testid="specialist-care-explore"
        className="mt-6 flex items-center justify-center gap-2 rounded-2xl py-3.5 text-white font-bold"
        style={{ background: "linear-gradient(90deg,#2563EB,#1D4ED8)" }}
      >
        Explore Specialist Services <ArrowRight className="h-4 w-4" />
      </div>
    </button>
  );
}
